import React from 'react'
import ReactDOM from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import App from './App.jsx'
import './index.css'

// Auth0 configuration matching the original app
const auth0Config = {
  domain: 'auth.ailex.aixpr.com',
  clientId: 'wMaMbkdYdv5hs7L504Nw3yob7Exy8sVk',
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: 'https://api.ailex.com',
    scope: 'openid profile email'
  },
  cacheLocation: 'localstorage',
  useRefreshTokens: true
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Auth0Provider {...auth0Config}>
      <App />
    </Auth0Provider>
  </React.StrictMode>,
)
